import React from "react";
import { cx } from "./Controls";

const SIZES = {
  sm: "h-10 min-w-[3.5rem] px-2 text-xl",
  md: "h-16 min-w-[5.5rem] px-3 text-4xl",
  lg: "h-20 min-w-[7rem] px-4 text-5xl",
};

export function VerdictStamp({ result, size = "md", testId }: { result: "OK" | "NG"; size?: keyof typeof SIZES; testId?: string }) {
  const ok = result === "OK";
  return (
    <span
      key={result}
      className={cx(
        "stamp-in inline-flex shrink-0 items-center justify-center rounded-lg border-[3px] font-display font-extrabold leading-none",
        ok ? "border-ok bg-ok-soft text-ok" : "border-ng bg-ng-soft text-ng",
        SIZES[size]
      )}
      aria-label={ok ? "Resultado OK" : "Resultado NG"}
      data-testid={testId}
    >
      {result}
    </span>
  );
}
